export class PersonCredentialPatchDatesModel {
  public updateCredentialDateType: UpdateCredentialDateType;
  public updatedDate: string;
  public note: string;
}

export enum UpdateCredentialDateType {
  IssueDate = 'IssueDate',
  ExpirationDate = 'ExpirationDate',
}
